import { render, staticRenderFns } from "./pickuplocation.vue?vue&type=template&id=65acdd9c"
import script from "./pickuplocation.vue?vue&type=script&lang=js"
export * from "./pickuplocation.vue?vue&type=script&lang=js"
import style0 from "./pickuplocation.vue?vue&type=style&index=0&id=65acdd9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports